/* eslint-disable react/jsx-closing-bracket-location */
import React, { ReactElement, useContext } from 'react';
import ContentLoader from 'react-content-loader';
import { THEME } from '../../constant';
import { PrefferencesContext } from '../../context/context';

type TableLoaderProps = {
  viewBox: string;
};

const TableLoader = ({ viewBox }: TableLoaderProps): ReactElement => {
  const { theme } = useContext(PrefferencesContext);

  return (
    <ContentLoader
      className="table-loader"
      speed={2}
      width="100%"
      height="100%"
      viewBox={viewBox}
      backgroundColor={theme === THEME.DARK ? '#6e7187' : '#f3f2f2'}
      foregroundColor={theme === THEME.DARK ? '#999' : '#e7e3e3'}>
      <rect x="10" y="30" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="50" r="20" />
      <rect x="130" y="30" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="30" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="30" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="30" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="30" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="30" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="30" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="100" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="120" r="20" />
      <rect x="130" y="100" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="100" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="100" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="100" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="100" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="100" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="100" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="170" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="190" r="20" />
      <rect x="130" y="170" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="170" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="170" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="170" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="170" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="170" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="170" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="240" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="260" r="20" />
      <rect x="130" y="240" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="240" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="240" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="240" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="240" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="240" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="240" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="310" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="330" r="20" />
      <rect x="130" y="310" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="310" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="310" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="310" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="310" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="310" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="310" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="380" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="400" r="20" />
      <rect x="130" y="380" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="380" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="380" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="380" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="380" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="380" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="380" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="450" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="470" r="20" />
      <rect x="130" y="450" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="450" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="450" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="450" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="450" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="450" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="450" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="530" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="550" r="20" />
      <rect x="130" y="530" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="530" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="530" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="530" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="530" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="530" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="530" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="600" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="620" r="20" />
      <rect x="130" y="600" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="600" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="600" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="600" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="600" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="600" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="600" rx="3" ry="3" width="50" height="40" />
      {/*  */}
      <rect x="10" y="670" rx="3" ry="3" width="40" height="40" />
      <circle cx="90" cy="690" r="20" />
      <rect x="130" y="670" rx="3" ry="3" width="160" height="40" />
      <rect x="315" y="670" rx="3" ry="3" width="240" height="40" />
      <rect x="580" y="670" rx="3" ry="3" width="135" height="40" />
      <rect x="740" y="670" rx="3" ry="3" width="30" height="40" />
      <rect x="795" y="670" rx="3" ry="3" width="180" height="40" />
      <rect x="1000" y="670" rx="3" ry="3" width="140" height="40" />
      <rect x="1160" y="670" rx="3" ry="3" width="50" height="40" />
    </ContentLoader>
  );
};

export default TableLoader;
